module.exports = __webpack_public_path__ + "static/img/led_l_4.eac645d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/led/led_l_4.png
// module id = IXw4
// module chunks = 4